import StorageManager from '../util/StorageManager'

const STORAGE_KEY = 'ACCESS_URL'

/**
 * アクセス時のURL情報を扱うためのUtilクラス
 */
class AccessUrl {
  /**
   * 保存
   * @param {*} val
   */
  static set (val) {
    StorageManager.setItem(STORAGE_KEY, val)
  }

  /**
   * 取得
   */
  static get () {
    return StorageManager.getItem(STORAGE_KEY)
  }

  /**
   * 削除
   */
  static remove () {
    StorageManager.removeItem(STORAGE_KEY)
  }
}

export default AccessUrl
